
export const COMPANY_USERS_ALERT_VOUCHER = {
  ADD_COMPANY_USERS_ALERT_VOUCHER_REQUEST: 'ADD_COMPANY_USERS_ALERT_VOUCHER_REQUEST',
  ADD_COMPANY_USERS_ALERT_VOUCHER_SUCCESS: 'ADD_COMPANY_USERS_ALERT_VOUCHER_SUCCESS',
  ADD_COMPANY_USERS_ALERT_VOUCHER_FAIL: 'ADD_COMPANY_USERS_ALERT_VOUCHER_FAIL'
};
